import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Table } from "react-bootstrap";
import { set } from "date-fns/esm";
import { param } from "jquery";
import Select, { components } from "react-select";

export default function ModalEditInTest(props) {
  const { lang, functions, proxy, database } = useSelector((state) => state);
  const {
    setModalEdit,
    index,
    fields,
    handleChange,
    setRefreshTable,
    dataModalEdit,
    LXH,
  } = props;
  const { data } = dataModalEdit;
  const [isData, setData] = useState([]);
  const [selectedSuggest, setSelectedSuggest] = useState([]);
  const [isDataEdit, setDataEdit] = useState(data);
  const _token = localStorage.getItem("_token");
  const [refresh, setRefresh] = useState(0);
  const [tempValue, setTempValue] = useState({
    alias: "",
    value: {},
  });

  const [isChange, setIsChange] = useState(false);
  const [inputFields, setInputFields] = useState([
    {
      label: "LXH/LĐĐNB",
      required: true,
      alias: "lenhXuatHangERP",
      readOnly: true,
      type: "text",
    },
    { label: "Mã Thành Phẩm", alias: "25MSP", readOnly: true, type: "text" },
    {
      label: "SL Tấn Còn Lại",
      alias: "SL Tấn Còn Lại",
      readOnly: true,
      type: "text",
    },
    // { label: "Số Hóa Đơn", alias: "4SHĐ", type: "text" },
    {
      label: "Số Lượng Tấn Cần Xuất",
      alias: "4SLCXTT",
      type: "number",
      isParamSuggest: true,
    },
    // { label: "Vị Trí Lấy Hàng", alias: "13VTLH", type: "text" },
    {
      label: "Gợi Ý Lệnh Đóng Bao",
      alias: "3MLĐB",
      type: "text",
      isSuggest: true,
      child: [
        { label: "Mã Lệnh Đóng Bao", alias: "3MLĐB" },
        { label: "Mã Thành Phẩm", alias: "SP" },
        { label: "Số Lot", alias: "SoLot" },
        { label: "SL Cần Xuất", alias: "SLX", color: "rgb(25, 14, 185)" },
        {
          label: "SL Đóng Bao Chưa Xuất",
          alias: "SLCX",
          color: "rgb(0, 171, 65)",
        },
      ],
    },
    { label: "Ghi Chú", alias: "2GCS", type: "textarea" },
  ]);
  const [paramSuggest, SetParamSuggest] = useState({
    alias: "",
    param: "",
  });
  const [tempParamSuggest, setTempParamSuggest] = useState({
    alias: "",
    param: "",
  });
  const [dataSuggest, setDataSuggest] = useState([]);
  const alias = fields.find((item) => item.isDisplay == false)?.alias;
  useEffect(() => {
    if (data?.dataEdit?.length > 0) {
      setSelectedSuggest(
        data.dataEdit.map((item) => ({
          label: item.label,
          value: item.label,
          ...item,
        }))
      );
    }
  }, [data]);
  useEffect(() => {
    fetch(`${proxy()}/api/PXK/optionLDB`, {
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const { data } = res;
        if (data.length > 0) {
          const alias = inputFields.find((item) => item.isSuggest).alias;
          const options = data.map((d) => {
            if (d[alias]) {
              return {
                value: d,
                label: d["label"],
                ...d,
              };
            }
          });
          setData(options);
        }
      });
  }, []);
  useEffect(() => {
    if (inputFields) {
      const field = inputFields.find((item) => item.isParamSuggest);
      if (field && field.isParamSuggest) {
        SetParamSuggest({
          alias: field.alias,
          param: data[field.alias],
        });
      }
    }
  }, [dataModalEdit, inputFields]);

  const handleCallDataSugges = (tempParamSuggest) => {
    const param = tempParamSuggest?.param
      ? tempParamSuggest?.param
      : paramSuggest.param;

    fetch(`${proxy()}/api/PXK/ldb/${param}`, {
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res && res.length > 0) {
          setDataSuggest(res);
          setSelectedSuggest(res);
          if (param) {
            const findAlias = inputFields.find((item) => item.isSuggest).alias;

            setTempValue({
              alias: alias,
              value: {
                ...tempValue.value,
                [findAlias]: res,
              },
            });
          }
        }
      });
  };

  useEffect(() => {
    // handleCallDataSugges();
    if (paramSuggest.param && !isChange) {
      const param = tempParamSuggest.param
        ? tempParamSuggest.param
        : paramSuggest.param;
      const encodedData = encodeURIComponent(
        JSON.stringify(isDataEdit?.["3MLĐB"])
      );

      fetch(`${proxy()}/api/PXK/ldb/${param}`, {
        headers: {
          Authorization: _token,
          "content-type": "application/json",
          isChange,
          DATA: encodedData,
        },
      })
        .then((res) => res.json())
        .then((res) => {
          if (res && res.length > 0) {
            const labelsInDataModal =
              data?.["3MLĐB"]?.map(({ value }) => value) || [];

            const defaultData = res.filter((item) =>
              labelsInDataModal.includes(item?.value)
            );
            if (defaultData.length > 0) {
              setDataSuggest(defaultData);
              setSelectedSuggest(defaultData);
            }
          }
        });
    }
  }, [paramSuggest, isChange, isDataEdit]);

  const CustomOption = ({ children, ...props }) => {
    return (
      <>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginRight: 10 }}
          />
          {children}
        </components.Option>
      </>
    );
  };
  return (
    <div>
      <>
        <div
          class="modal fade"
          id="ModalEditInTest"
          tabindex="-1"
          aria-labelledby="ModalEditInTest"
          aria-hidden="true"
          data-backdrop="static"
        >
          <div className="modal-dialog">
            <div className="modal-content custome">
              <div className="modal-header justify-content-start">
                <span style={{ fontSize: "18px" }}>{lang["edit"]}</span>
                {/* <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  onClick={() => setModalEdit(false)}
                >
                  &times;
                </button> */}
              </div>
              <div
                className="modal-body"
                style={{
                  height: "70vh",
                  overflowY: "auto",
                  overflowX: "unset",
                }}
              >
                <form
                  className=""
                  style={{
                    padding: "5px 5em",
                  }}
                >
                  {inputFields.map((item, _index) => {
                    const mappedOpts = isData.filter(
                      (d) => !selectedSuggest?.some((e) => e._id === d._id)
                    );
                    const findSTCL = LXH?.find(
                      (lxh) =>
                        lxh["lenhXuatHangERP" || "2MLXH"] === data["4LXH"]
                    );
                    return item.type === "textarea" ? (
                      <>
                        <label className="form-label">{item.label}</label>
                        <textarea
                          className="form-control"
                          rows={3}
                          onChange={(e) => {
                            const { value } = e.target;
                            if (item.isParamSuggest) {
                              SetParamSuggest({
                                alias: item.alias,
                                param: value,
                              });
                            }
                            setTempValue({
                              alias: alias,
                              value: {
                                ...tempValue.value,
                                [item.alias]: value,
                              },
                            });
                          }}
                        ></textarea>
                      </>
                    ) : (
                      <div className="mb-3" key={_index}>
                        <label className="form-label">{item.label}</label>
                        <div className="d-flex">
                          {!item.isSuggest ? (
                            <input
                              type={item.type}
                              className="form-control"
                              placeholder=""
                              defaultValue={
                                Array.isArray(data[item.alias])
                                  ? data[item?.alias].map((d) => d[item.alias])
                                  : typeof data[item.alias] === "object" &&
                                    data[item.alias] !== null
                                  ? `${data[item.alias]?.MaSP} | ${
                                      data[item.alias]?.TenSP
                                    }`
                                  : data[item.alias] || findSTCL?.[item.alias]
                              }
                              readOnly={item.readOnly ? true : false}
                              onBlur={(e) => {
                                const { value } = e.target;

                                if (item.alias === "4SLCXTT" && value) {
                                  const roundedValue =
                                    parseFloat(value).toFixed(3);

                                  data[item.alias] = Number(roundedValue);

                                  setTempValue({
                                    alias: alias,
                                    value: {
                                      ...tempValue.value,
                                      [item.alias]: Number(roundedValue),
                                    },
                                  });
                                }
                              }}
                              onChange={(e) => {
                                const { value } = e.target;
                                const numericValue = parseFloat(value);
                                if (!isNaN(numericValue) && numericValue < 0) {
                                  setTempValue({
                                    alias: alias,
                                    value: {
                                      ...tempValue.value,
                                      [item.alias]: 0,
                                    },
                                  });
                                } else {
                                  if (item.isParamSuggest) {
                                    // setDataSuggest([])
                                    setDataSuggest([]);
                                    setDataEdit((prev) => ({
                                      ...prev,
                                      ["3MLĐB"]: [],
                                    }));
                                    setSelectedSuggest([]);
                                    setTempParamSuggest({
                                      alias: item.alias,
                                      param: value,
                                    });
                                    setIsChange(true);
                                  }
                                  setTempValue({
                                    alias: alias,
                                    value: {
                                      ...tempValue.value,
                                      [item.alias]: value,
                                    },
                                  });
                                }
                              }}
                            />
                          ) : (
                            <Select
                              options={mappedOpts}
                              components={{
                                Option: CustomOption,
                              }}
                              value={selectedSuggest}
                              onChange={(options) => {
                                const cal = options.map((item) => {
                                  const { QC, SoLuong, SLDQ } = item;
                                  const Tan = (SoLuong * QC) / 1000;
                                  const params = paramSuggest.param;
                                  const SoLuongCanLay =
                                    (params || 0) - Tan > 0 ? Tan : params || 0;
                                  const SoBao =
                                    (params || 0) - Tan > 0
                                      ? SoLuong
                                      : Math.ceil(((params || 0) * 1000) / QC);
                                  const SoTan = (Tan - SoLuongCanLay).toFixed(
                                    2
                                  );

                                  return {
                                    ...item,
                                    SLX: `${SoBao} Bao\n${SoLuongCanLay} Tấn`,
                                    SLCX: `${
                                      SoLuong - SoBao
                                    } Bao\n${SoTan} Tấn`,
                                  };
                                });
                                setSelectedSuggest(options);
                                setDataEdit(options);
                                setDataSuggest(cal);
                                // data.dataEdit = options;

                                setTempValue({
                                  alias: alias,
                                  value: {
                                    ...tempValue.value,
                                    [item.alias]: cal,
                                    dataEdit: cal,
                                  },
                                });
                              }}
                              isMulti
                              isSearchable={true}
                              closeMenuOnSelect={false}
                              hideSelectedOptions={false}
                              styles={{
                                container: (base) => ({
                                  ...base,
                                  width: "100%",
                                }),
                                menuList: (base) => ({
                                  ...base,
                                  maxHeight: "300px",
                                }),
                                menu: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                              additional={{
                                page: 0,
                              }}
                              noOptionsMessage={() => (
                                <div style={{ fontWeight: "300" }}>
                                  {lang["not found data"]}
                                </div>
                              )}
                            />
                          )}
                          {item.isSuggest ? (
                            <>
                              <div
                                className="btn btn-success mt-0 ml-3"
                                onClick={() => {
                                  SetParamSuggest({ ...tempParamSuggest });
                                  handleCallDataSugges(tempParamSuggest);
                                }}
                              >
                                Gợi Ý
                              </div>
                            </>
                          ) : null}
                        </div>
                        {item.isSuggest ? (
                          <div style={{ overflow: "auto" }}>
                            <Table className="table table-custom mt-3">
                              <thead>
                                <tr>
                                  {item?.child?.map((header) => {
                                    return <td>{header.label}</td>;
                                  })}
                                </tr>
                              </thead>
                              <tbody>
                                {(dataSuggest && dataSuggest?.length > 0
                                  ? dataSuggest
                                  : isDataEdit[item?.alias]
                                )?.map((data, index) => {
                                  return (
                                    <tr key={index}>
                                      {item?.child?.map(({ alias, color }) => {
                                        return (
                                          <td
                                            style={{
                                              color: color,
                                              textAlign: "left",
                                              whiteSpace: "pre",
                                            }}
                                          >
                                            {data[alias]}
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </Table>
                          </div>
                        ) : null}
                      </div>
                    );
                  })}
                </form>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => setModalEdit(false)}
                >
                  {lang["btn.close"]}
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    setRefreshTable((prev) => prev + 1);
                    if (Object.values(tempValue.value).length > 0) {
                      handleChange(
                        { alias: tempValue.alias, index: dataModalEdit.index },
                        { ...tempValue.value }
                      );
                    }
                    setModalEdit(false);
                  }}
                >
                  {lang["btn.update"]}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
}
